import { CUI_REGEX, EMAIL_REGEX, PASSWORD_REGEX } from "../lib/variables";

const regiterUserValidation = (obj, setInputError, signupAs) => {
  let hasError = false;

  if (!obj.fname) {
    setInputError((prev) => ({ ...prev, fname: true }));
    hasError = true;
  }
  if (signupAs === "individual" && !obj.lname) {
    setInputError((prev) => ({ ...prev, lname: true }));
    hasError = true;
  }
  if (signupAs === "business" && !obj.cui) {
    setInputError((prev) => ({ ...prev, cui: true }));
    hasError = true;
  }
  if (signupAs === "business" && obj.cui && !CUI_REGEX.test(obj.cui)) {
    setInputError((prev) => ({ ...prev, isValidCui: true }));
    hasError = true;
  }
  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (obj.email && !EMAIL_REGEX.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isValidEmail: true }));
    hasError = true;
  }

  if (!obj.contact) {
    setInputError((prev) => ({ ...prev, contact: true }));
    hasError = true;
  }

  if (!obj.password) {
    setInputError((prev) => ({ ...prev, password: true }));
    hasError = true;
  }

  if (obj.password && !PASSWORD_REGEX.test(obj.password)) {
    setInputError((prev) => ({ ...prev, isStrongPassword: true }));
    hasError = true;
  }

  return hasError;
};

const loginValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (obj.email && !EMAIL_REGEX.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isEmailValid: true }));
    hasError = true;
  }

  if (!obj.password) {
    setInputError((prev) => ({ ...prev, password: true }));
    hasError = true;
  }

  return hasError;
};

const joinWaitlistValidation = (obj, setInputError) => {
  let hasError = false;

  for (const [key, value] of Object.entries(obj)) {
    if (!value) {
      setInputError((prev) => ({ ...prev, [key]: true }));
      hasError = true;
    } else if (key == "subService" && value.length == 0) {
      setInputError((prev) => ({ ...prev, [key]: true }));
      hasError = true;
    } else if (key == "email" && !EMAIL_REGEX.test(value)) {
      setInputError((prev) => ({ ...prev, isEmailValid: true }));
      hasError = true;
    }
  }
  return hasError;
};

const forgetPasswordValidation = (email, setInputError) => {
  let hasError = false;

  if (!email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (email && !EMAIL_REGEX.test(email)) {
    setInputError((prev) => ({ ...prev, isEmailValid: true }));
    hasError = true;
  }

  return hasError;
};

const resretPasswordValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.password) {
    setInputError((prev) => ({ ...prev, password: true }));
    hasError = true;
  }

  if (obj.password && !PASSWORD_REGEX.test(obj.password)) {
    setInputError((prev) => ({ ...prev, isStrongPassword: true }));
    hasError = true;
  }

  if (!obj.confirmPassword) {
    setInputError((prev) => ({ ...prev, confirmPassword: true }));
    hasError = true;
  }

  if (obj.confirmPassword && obj.password !== obj.confirmPassword) {
    setInputError((prev) => ({ ...prev, isConfirmPassword: true }));
    hasError = true;
  }

  return hasError;
};

const updateUserValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.fname) {
    setInputError((prev) => ({ ...prev, fname: true }));
    hasError = true;
  }
  if (obj?.workerBgImages?.length < 2) {
    setInputError((prev) => ({ ...prev, workerBgImages: true }));
    hasError = true;
  }
  if (!obj.lname) {
    setInputError((prev) => ({ ...prev, lname: true }));
    hasError = true;
  }
  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (obj.email && !EMAIL_REGEX.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isValidEmail: true }));
    hasError = true;
  }

  if (!obj.contact) {
    setInputError((prev) => ({ ...prev, contact: true }));
    hasError = true;
  }

  return hasError;
};

const changePasswordValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.newPassword) {
    setInputError((prev) => ({ ...prev, newPassword: true }));
    hasError = true;
  }

  if (obj.newPassword && !PASSWORD_REGEX.test(obj.newPassword)) {
    setInputError((prev) => ({ ...prev, isPasswordStrong: true }));
    hasError = true;
  }

  if (!obj.reEnterPassword) {
    setInputError((prev) => ({ ...prev, reEnterPassword: true }));
    hasError = true;
  }

  if (obj.newPassword !== obj.reEnterPassword) {
    setInputError((prev) => ({ ...prev, isPasswordMatch: true }));
    hasError = true;
  }

  if (!obj.oldPassword) {
    setInputError((prev) => ({ ...prev, oldPassword: true }));
    hasError = true;
  }

  return hasError;
};

const regiterUserAddressValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.fname) {
    setInputError((prev) => ({ ...prev, fname: true }));
    hasError = true;
  }
  if (!obj.lname) {
    setInputError((prev) => ({ ...prev, lname: true }));
    hasError = true;
  }
  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (obj.email && !EMAIL_REGEX.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isValidEmail: true }));
    hasError = true;
  }

  if (!obj.contact) {
    setInputError((prev) => ({ ...prev, contact: true }));
    hasError = true;
  }

  if (!obj.state) {
    setInputError((prev) => ({ ...prev, state: true }));
    hasError = true;
  }

  if (!obj.city) {
    setInputError((prev) => ({ ...prev, city: true }));
    hasError = true;
  }

  if (!obj.zipCode) {
    setInputError((prev) => ({ ...prev, zipCode: true }));
    hasError = true;
  }

  if (!obj.address) {
    setInputError((prev) => ({ ...prev, address: true }));
    hasError = true;
  }

  return hasError;
};

const addReviewValidation = (obj, setInputError) => {
  let hasError = false;

  if (obj.rating == 0) {
    setInputError((prev) => ({ ...prev, rating: true }));
    hasError = true;
  }
  if (!obj.comment) {
    setInputError((prev) => ({ ...prev, comment: true }));
    hasError = true;
  }

  return hasError;
};

const contactSupportValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (obj.email && !EMAIL_REGEX.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isEmailValid: true }));
    hasError = true;
  }

  if (!obj.message) {
    setInputError((prev) => ({ ...prev, message: true }));
    hasError = true;
  }

  return hasError;
};

const createUserPackageValidation = (obj, setInputError) => {
  let hasError = false;

  const errors = {
    name_en: !obj.name_en,
    name_ro: !obj.name_en,
    categoryId: !obj.categoryId,
  };

  // Set the error state
  setInputError(errors);

  // Check if any field has an error
  hasError = Object.values(errors).some(Boolean);

  return hasError;
};

const updateBankAccountValidation = (obj, setInputError) => {
  let hasError = false;

  const errors = {
    accountHolderName: !obj.accountHolderName,
    iban: !obj.iban,
    isValidIban: obj.iban && !/^RO\d{2}[A-Z]{4}[0-9A-Z]{16}$/.test(obj.iban),
    bankName: !obj.bankName,
  };

  // Set the error state
  setInputError(errors);

  // Check if any field has an error
  hasError = Object.values(errors).some(Boolean);

  return hasError;
};

export {
  regiterUserValidation,
  loginValidation,
  forgetPasswordValidation,
  resretPasswordValidation,
  updateUserValidation,
  changePasswordValidation,
  regiterUserAddressValidation,
  addReviewValidation,
  joinWaitlistValidation,
  contactSupportValidation,
  createUserPackageValidation,
  updateBankAccountValidation,
};
